"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var qs_1 = __importDefault(require("qs"));
var api_base_1 = __importDefault(require("./api_base"));
var api_base_2 = __importDefault(require("../api_base"));
var CustomerLoyaltyMode;
(function (CustomerLoyaltyMode) {
    CustomerLoyaltyMode["HIERARCHY"] = "hierarchy";
    CustomerLoyaltyMode["FLATTENED"] = "flattened";
})(CustomerLoyaltyMode = exports.CustomerLoyaltyMode || (exports.CustomerLoyaltyMode = {}));
exports.default = {
    get: function (organizationId, params, facetParams) {
        var query = qs_1.default.stringify(params);
        var facetsQuery = qs_1.default.stringify(facetParams);
        return Promise.all([
            api_base_1.default.get("organizations/" + organizationId + "/customer_loyalty?" + query),
            api_base_1.default.get("organizations/" + organizationId + "/customer_loyalty/facets?" + facetsQuery),
            api_base_2.default.get("organizations/" + organizationId + "/vocabulary")
        ]).then(function (_a) {
            var report = _a[0], facets = _a[1], vocabulary = _a[2];
            return {
                facets: facets.data.data,
                data: report.data.data,
                totalPages: report.data.meta.total_pages,
                totalRecords: report.data.meta.total_records,
                vocabulary: vocabulary.data.data
            };
        });
    }
};
//# sourceMappingURL=customer_loyalty.js.map